import { createSlice } from "@reduxjs/toolkit";
import { getFilterOptions } from "src/apis/filter";

const initialState = {
  genre: [],
  lang: [],
  producer: [],
  country: [],
};

const slice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    fetctOptionsSuccess(state, action) {
      const { by, options } = action.payload;
      state[by] = options;
    },
  },
});

// Reducer
export default slice.reducer;

export function fetchOptions({ by }) {
  return async (dispatch) => {
    try {
      const response = await getFilterOptions({ by });
      dispatch(
        slice.actions.fetctOptionsSuccess({ by, options: response.data })
      );
    } catch (error) {
      console.error(error);
    }
  };
}
